<div class="modal-header" style="padding: 1rem 1.5rem;">
  <div>
    <h4 class="modal-title" style="font-family: 'Rubik', serif; font-weight: 400; margin-bottom: 2px;">
      {{ getFirstSegment()?.departure?.city }} / {{ getLastSegment()?.arrival?.city }} ({{ getStopsLabel() }})
    </h4>
    <p style="margin-bottom: 0; font-size: 14px; color: #666; text-transform: capitalize;">
      {{ formatDate(getFirstSegment()?.departure?.dateTime) }}
    </p>
  </div>
  <button type="button" class="btn-close close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 1.5rem; max-height: 75vh; overflow-y: auto;">

  <!-- TRAMO: resumen del tramo completo (todos los segmentos, con escalas) -->
  <div style="border: 1px solid #e9ecef; border-radius: 8px; overflow: hidden; margin-bottom: 1rem;">
    <div style="background-color: #e9ecef; padding: 8px 16px; font-size: 12px; font-weight: 700; letter-spacing: .5px; color: #555;">
      TRAMO
    </div>

    <ng-container *ngFor="let segment of getAllSegments(); let i = index; let last = last">

      <ng-container *ngIf="selectedSegmentIndex === i">

          <div class="d-flex align-items-center justify-content-between flex-wrap" style="padding: 1.25rem; gap: 10px;">

          <div class="d-flex justify-content-between align-items-center px-3 w-100">
            <div>
              <p class="date-info-result-flight-hour">{{ formatTime(segment?.departure?.dateTime) }}</p>
              <p class="date-info-result-flight-city">{{ segment?.departure?.city }}</p>
              <p class="date-info-result-flight-iata">{{ segment?.departure?.airport }}</p>
            </div>
            <div class="d-flex flex-column align-items-center" style="position: relative">
              <p class="date-info-result-flight-class">{{ segment?.cabin?.category }}</p>
              <p class="date-info-result-flight-duration">{{ segment?.cabin?.class }} {{ segment?.cabin?.fareBasis }}</p>
              <p class="date-info-result-flight-segment">{{ segment?.flightNumber }}</p>

              <div class="d-flex align-items-center" st yle="width: 100%; margin-top: 10px; gap: 6px">
                <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;width: 75px;"></div>
                <img src="../../../../../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 26px;transform: rotate(90deg); flex-shrink: 0; margin: 0 6px;" alt="">
                <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;width: 75px;"></div>
              </div>

              <img class="date-info-result-image" [src]="segment?.airline?.operatingLogo" alt="">
            </div>
            <div class="d-flex flex-column align-items-end">
              <p class="date-info-result-flight-hour">{{ formatTime(segment?.arrival?.dateTime) }}</p>
              <p class="date-info-result-flight-city">{{ segment?.arrival?.city }}</p>
              <p class="date-info-result-flight-iata">{{ segment?.arrival?.airport }}</p>
            </div>
          </div>

        </div>

      </ng-container>

      </ng-container>

      <!-- <ng-container *ngFor="let segment of getAllSegments(); let i = index; let last = last">
        <div class="text-center" style="flex: 0 0 auto;">
          <div class="d-flex align-items-center">
            <div style="width: 40px; height: 2px; background-color: black;"></div>
            <img src="../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 30px;transform: rotate(90deg); flex-shrink: 0; margin: 0 6px;" alt="">
            <div style="width: 40px; height: 2px; background-color: black;"></div>
          </div>
          <p style="margin: 4px 0 0; font-size: 11px; color: #666;">
            {{ segment.cabin?.brandName || segment.cabin?.class }}<br/>
            {{ segment.airline?.code }} {{ segment.flight?.number }}<br/>
            {{ segment.flight?.equipment }}
          </p>
        </div>

        <div *ngIf="!last" class="text-center">
          <p style="margin-bottom: 2px; font-size: 12px; font-weight: 600; color: #333;">Escala</p>
          <p style="margin-bottom: 0; font-size: 11px; color: #666;">{{ formatDuration(calculateLayover(i)) }}</p>
          <p style="margin-bottom: 0; font-size: 12px; font-weight: 600; color: #333;">
            {{ segment.arrival?.time }} / {{ getAllSegments()[i+1]?.departure?.time }}
          </p>
          <p style="margin-bottom: 0; font-size: 11px; color: #666;">{{ segment.arrival?.airport }}</p>
        </div>
      </ng-container> -->

      <!-- <div class="text-center">
        <h3 style="font-size: 22px; font-weight: 700; margin-bottom: 0; color: #333;">
          {{ formatTime(getLastSegment()?.arrival?.dateTime) }}
        </h3>
        <p style="margin-bottom: 0; font-size: 13px; color: #666;">{{ getLastSegment()?.arrival?.airport }}</p>
      </div> -->


    <!-- Navegación por tramo (sólo si hay escalas) -->
    <div *ngIf="getAllSegments().length > 1" style="border-top: 1px solid #e9ecef;">
      <div class="d-flex align-items-center justify-content-between" style="padding: 10px 16px;">
        <div class="d-flex align-items-center" style="gap: 18px; flex-wrap: wrap;">
          <ng-container *ngFor="let step of getTramoSteps()">
            <button
              *ngIf="step.type === 'tramo'"
              type="button"
              (click)="selectSegment(step.segmentIndex)"
              [style.color]="selectedSegmentIndex === step.segmentIndex ? '#000' : '#999'"
              [style.font-weight]="selectedSegmentIndex === step.segmentIndex ? '700' : '500'"
              style="background: none; border: none; font-size: 12px; letter-spacing: .5px; padding: 0;"
            >
              {{ step.label }}
            </button>
            <span *ngIf="step.type === 'escala'" style="font-size: 12px; color: #999;">{{ step.label }}</span>
          </ng-container>
        </div>
        <button
          type="button"
          *ngIf="hasNextSegment()"
          (click)="nextSegment()"
          style="background: none; border: none; color: #333; font-size: 16px;"
        >
          &rsaquo;
        </button>
      </div>
      <div style="height: 3px; background-color: #e9ecef;">
        <div
          [style.width]="((selectedSegmentIndex + 1) / getAllSegments().length * 100) + '%'"
          style="height: 100%; background-color: #000000; transition: width .2s ease;"
        ></div>
      </div>
    </div>
  </div>

             <div class="usb-modal-experience-container pt-3 mb-4">
                <p class="usb-modal-experience-subtitle mb-1" style="font-family: 'Poppins', sans-serif; font-size: 18px;font-weight: 600; padding: 0px 12px;">Información</p>

                <div class="row">

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-3 px-2"
                    style="gap: 10px; border-top: 1px solid #b4b4b4; border-right: 1px solid #b4b4b4"
                  >
                    <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Desde</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.departure?.airport }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-3 px-2" style="gap: 10px; border-top: 1px solid #b4b4b4">
                    <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hasta</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.arrival?.airport }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-3 px-2"
                    style="gap: 10px; border-top: 1px solid #b4b4b4; border-right: 1px solid #b4b4b4"
                  >
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column" >
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hora de salida</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedSegment()?.departure?.dateTime) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-3 px-2" style="gap: 10px; border-top: 1px solid #b4b4b4">
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hora de llegada</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedSegment()?.arrival?.dateTime) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-3 px-2"
                    style="gap: 10px; border-top: 1px solid #b4b4b4; border-right: 1px solid #b4b4b4;border-bottom: 1px solid #b4b4b4"
                  >
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column" >
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Información de viaje</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">tipo de vuelo: {{formatDuration(flightData?.itinerary[0]?.duration)}}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-3 px-2" style="gap: 10px; border-top: 1px solid #b4b4b4;border-bottom: 1px solid #b4b4b4">
                  <img src="../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 16px;transform: rotate(45deg); flex-shrink: 0;" alt="">

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Vuelo</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.airline?.code }} {{ getSelectedSegment()?.flight?.number }}
                        ({{ getSelectedSegment()?.flight?.equipment }})</p>
                    </div>
                  </div>
                </div>

                </div>
             </div>


  <!-- Familias tarifarias -->
  <!-- <h5 style="font-weight: 600; margin-bottom: 1rem;">Tarifas disponibles</h5> -->

  <div *ngIf="loadingFareOptions" class="text-center" style="padding: 2rem 0; color: #666;">
    Buscando tarifas disponibles...
  </div>

  <div *ngIf="!loadingFareOptions && fareOptionsError" class="text-center" style="padding: 1.5rem; background-color: #fff3e0; border-radius: 8px;">
    <p style="margin-bottom: 10px; font-size: 14px;">No pudimos traer las tarifas alternativas para este vuelo.</p>
    <button
      type="button"
      class="btn"
      [disabled]="processing"
      (click)="chooseFare(null)"
      style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.4rem 1.2rem;"
    >
      Continuar con la tarifa original
    </button>
  </div>

  <!-- usb-carousel (mismo carrusel compartido que usa destination-big/shortcuts): breakpoints
       para que se vean 4 tarjetas en el ancho del modal y menos en pantallas chicas. -->
  <usb-carousel
    #fareCarousel
    *ngIf="!loadingFareOptions && !fareOptionsError"
    [items]="fareOptions"
    [breakpoints]="fareCarouselBreakpoints"
    [showArrows]="fareOptions.length > 1"
  >
    <ng-template #slideTemplate let-fare let-i="index">
      <div style="overflow: hidden; display: flex; flex-direction: column; margin: 0 6px;">
        <div
          [style.background-color]="getFareHeaderColor(i, fareCarousel.visibleRealIndices)"
          [style.color]="getFareHeaderTextColor(i, fareCarousel.visibleRealIndices)"
          style="padding: 10px 14px; font-size: 15px; border-radius: 10px; margin-bottom: 10px;height: 70px; display: flex; align-items: center;justify-content: center;"
        >
          <p style="font-family: 'Poppins', sans-serif;font-size: 14px;font-weight: 500;margin-bottom: 0px;text-align: center;"> {{ getFareLabel(fare) }}</p>
        </div>

        <div style="padding: 14px; flex: 1;border: 1px solid #e9ecef; border-radius: 10px;margin-bottom: 10px; ">
          <div *ngFor="let group of getFareFeatureGroups(fare)" style="margin-bottom: 12px;">
            <p style="margin-bottom: 4px; font-size: 11px; font-weight: 700; text-transform: uppercase; color: #333;">
              {{ group.title }}
            </p>
            <ul style="padding-left: 18px; margin-bottom: 0;">
              <li *ngFor="let line of group.lines" style="font-size: 12px; color: #555; margin-bottom: 4px;">
                {{ line }}
              </li>
            </ul>
          </div>
        </div>

        <div style="padding: 14px; border: 1px solid #e9ecef; border-radius: 10px;margin-bottom: 10px; text-align: center;">
          <div style="display: inline-block; text-align: left;">
            <p style="margin-bottom: 2px; font-size: 20px; font-weight: 700; color: #333;">
              {{ currencyAgency?.code }} {{ getFarePrice(fare) | number: '1.2-2' }}
            </p>
            <p style="margin-bottom: 0px; font-size: 11px; color: #999;">Por pasajero</p>
            <p style="margin-bottom: 10px; font-size: 11px; color: #999;">incluye tasas e impuestos</p>
          </div>
        </div>

        <button
            type="button"
            class="btn w-100"
            [disabled]="processing"
            (click)="chooseFare(fare)"
            style="color: black;"
            [style.background-color]="clientsSettingAppBooking?.clients_setting_global?.color_main_1 || '#000000'"
          >
            {{ processing && isFareChosen(fare) ? 'Procesando...' : 'Elegir' }}
          </button>
      </div>
    </ng-template>
  </usb-carousel>

</div>
